/**
 * DevExtreme (esm/__internal/pagination/info.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { createVNode } from "inferno";
import { BaseInfernoComponent } from "../core/r1/runtime/inferno/index";
import { createRef as infernoCreateRef } from "inferno";
import { format } from "../../core/utils/string";
import { PaginationDefaultProps } from "./common/pagination_props";
import { getLocalizationMessage } from "./utils/compatibility_utils";
export const PAGER_INFO_CLASS = "dx-info";
const InfoTextDefaultProps = {
  pageCount: PaginationDefaultProps.pageCount,
  pageIndex: PaginationDefaultProps.pageIndex,
  itemCount: PaginationDefaultProps.itemCount
};
export let InfoText = /*#__PURE__*/(() => {
  class InfoText extends BaseInfernoComponent {
    constructor() {
      super(...arguments);
      this.state = {};
      this.refs = null;
      this.rootElementRef = infernoCreateRef();
    }
    getInfoText() {
      return this.props.infoText ?? getLocalizationMessage(this.context, "dxPagination-infoText");
    }
    getText() {
      const {
        pageCount: pageCount,
        pageIndex: pageIndex,
        itemCount: itemCount
      } = this.props;
      return format(this.getInfoText(), (pageIndex + 1).toString(), null === pageCount || void 0 === pageCount ? void 0 : pageCount.toString(), null === itemCount || void 0 === itemCount ? void 0 : itemCount.toString());
    }
    render() {
      return createVNode(1, "div", "dx-info", this.getText(), 0, null, null, this.props.rootElementRef);
    }
  }
  InfoText.defaultProps = InfoTextDefaultProps;
  return InfoText;
})();